import DOMPurify from 'dompurify';

import { EcmDispatcherModule } from '../ecm-dispatcher.module';
import { EcmGlobalThisUtil } from './ecm-global-this.util';

export class EcmUrlSanitizerUtil {
    public static handleAndSanitizeRoutingUri(routing: string): string {
        return this.handlePreviousPageLinkWithDomSanitizer(routing);
    }

    public static handlePreviousPageLinkWithDomSanitizer(routing?: string): string {
        const defaultUrl = EcmGlobalThisUtil.getLocation().origin;

        if (!routing) {
            return routing;
        }
        EcmDispatcherModule.sendConsoleDebug(
            EcmUrlSanitizerUtil.name,
            '🚀 ~ EcmUrlSanitizerUtil ~ handlePreviousPageLinkWithDomSanitizer ~ routing: ' + routing,
        );

        const decodedRouting = EcmUrlSanitizerUtil.decodeRoutingSafely(routing);

        if (EcmUrlSanitizerUtil.isSafeRelativePath(decodedRouting)) {
            return routing;
        }

        let sanitizedUrl = null;

        const checkSanity = DOMPurify.sanitize(`<a href="${decodedRouting}">link</a>`, {
            ALLOWED_TAGS: ['a'],
            ALLOWED_ATTR: ['href'],
            // Limit allowed protocols for href
            ALLOWED_URI_REGEXP: /^(?:(?:https?):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))/i,
            RETURN_DOM: false,
        });

        if (!checkSanity.includes('href')) {
            return defaultUrl;
        }

        try {
            sanitizedUrl = new URL(decodedRouting);
        } catch {
            sanitizedUrl = null;
        }

        if (!sanitizedUrl) {
            return routing;
        }
        const HOST_REGEXP = /^(.*[.])?(orange|sosh)\.fr$/gm;
        const sanitizeHostname = sanitizedUrl.hostname;
        if (routing && !HOST_REGEXP.test(sanitizeHostname)) {
            return defaultUrl;
        }
        return routing;
    }

    public static decodeRoutingSafely(value: string, maxDepth = 5): string {
        let decodedValue = value.trim();

        for (let depth = 0; depth < maxDepth; depth += 1) {
            const nextValue = decodeURIComponent(decodedValue);
            if (nextValue === decodedValue) {
                break;
            }
            decodedValue = nextValue;
        }

        return decodedValue.trim();
    }

    public static isSafeRelativePath(value: string): boolean {
        const sanitized = value.trim();

        if (!sanitized) {
            return false;
        }

        if (sanitized.startsWith('//') || sanitized.startsWith('\\')) {
            return false;
        }

        return !/^[a-zA-Z][\w+.-]*:/.test(sanitized);
    }
}
